var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('drag-drop-description'),_c('drag-drop-simple'),_c('drag-drop-multiple-list'),_c('drag-drop-clone'),_c('drag-drop-animation')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }